<script lang="ts" setup>
import { type IContentElement, logInteraction } from '@bosca/analytics-client-browser'

export type LinkType = 'button' | 'image-button' | 'image-card' | 'card' | 'avatar' | undefined

const props = defineProps<{
  id: string
  type?: LinkType
  to?: string | undefined | import('vue-router').RouteLocationAsRelativeGeneric | import('vue-router').RouteLocationAsPathGeneric
  href?: string | undefined | import('vue-router').RouteLocationAsRelativeGeneric | import('vue-router').RouteLocationAsPathGeneric
  extras?: { [key: string]: string } | undefined
  content?: IContentElement[] | []
  click?: (() => void) | undefined
}>()

function onClick() {
  logInteraction({
    id: props.id,
    type: props.type || 'button',
    extras: props.extras || {},
    content: props.content || [],
  })
}
</script>

<template>
  <NuxtLink
    v-if="to"
    :to="to"
    @click="() => { if (click) { click() } onClick(); }"
  >
    <slot />
  </NuxtLink>
  <a
    v-else
    :href="href?.toString() || '#'"
    @click="() => { if (click) { click() } onClick(); }"
  >
    <slot />
  </a>
</template>
